import React, { useEffect, useState } from 'react';
import {
  InputGrid,
  useResponsiveParams,
  Text,
  useQuantaFormikContext,
  QuantaInput,
} from 'quanta-ui';
import {
  GET_PCV_POLICY_VAR_DETAILS,
  INSURED_DECLARED_VALUE,
} from '../../queries';
import {Loading} from 'quanta-flows/modules/layout';
import {Error} from 'quanta-flows/modules/layout';
//import Parse from '../../../../../../lib/intl/CurrencyFormater';
// Parse is changed to CurrencyFormater
import {CurrencyFormater} from 'quanta-flows';
import { useQuery } from '@apollo/client';
//import useFetchQuery from './lib/graphql/useFetchCacheQuery';
import { useFetchQuery } from 'quanta-flows';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { text } from '@fortawesome/fontawesome-svg-core';

export default function InsuredDeclaredForm({
  makeCode,
  varientCode,
  rtoCode,
  branding,
  setFieldValue,
  lobCode,
  lobName,
  productCode,
  productName,
  quoteNumber,
  dateOfReg,//SAIDVissue
  modify,
  pastPolicyExpiryDate,
  anyPreviousPolicyforVehicleTaken,
  businessType,
  vehicleUsevalue
}) {
  const { values } = useQuantaFormikContext();
  const fetchQuery = useFetchQuery();
  const [loadingIDVValues, setLoadingIDVValues] = useState(false);
  const [errorIDVValues, setErrorIDVValues] = useState(null);
  const [idvValues, setIdvValues] = useState(null);
  const repeatForMobile = 1,
    repeatForDesktop = 3;

  let repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: repeatForDesktop,
  });
let result= parseFloat(values?.bodyIDV)+parseFloat(values?.changedIDV)

  useEffect(() => {
    let isMounted = true;
    if (
      isMounted &&
      makeCode &&
      varientCode &&
      rtoCode &&
      //!values?.quotationNo check
       !(values?.quotationNo !== '' && !modify) 
    ) {
      setErrorIDVValues(null);
      setLoadingIDVValues(true);
      fetchQuery({
        query: GET_PCV_POLICY_VAR_DETAILS,
      })?.then((response) => {
       
        fetchQuery({
          query: INSURED_DECLARED_VALUE,
          fetchPolicy:'network-only',
          variables: {
            
            input: {
              makeCode,
              varientCode,
              rtoCode,
              imdCode:
                response?.data?.selectedIntermediary
                  ?.intermediaryCode ||
                response?.data?.motorQuote?.intermediaryDetails?.code,
               dateOfReg,//SAIDVissue
              productCode,
              businessType: businessType,
              pastPolicyExpDate:anyPreviousPolicyforVehicleTaken
                ?.toString()?.toLowerCase() === 'yes'
                ? pastPolicyExpiryDate : null,
              vehicleUse:vehicleUsevalue,
            },
          },
        })
          ?.then((response) => {
            if (isMounted) {
              const { data: idvData } = response;
              setFieldValue(
                `changedIDV`,
                `${
                  parseFloat(values?.suggestedIDV) !==
                    parseFloat(
                      idvData?.insuredDeclaredValue?.suggestedIDV,
                    )
                    ?idvData?.insuredDeclaredValue?.suggestedIDV
                    : values?.changedIDV
                }`,
                // `${idvData?.insuredDeclaredValue?.suggestedIDV}`,
              );
              setFieldValue(
                `suggestedIDV`,
                `${idvData?.insuredDeclaredValue?.suggestedIDV}`,
              );
              setFieldValue(
                `minSuggestedIDV`,
                `${idvData?.insuredDeclaredValue?.minSuggestedIDV}`,
              );
              setFieldValue(
                `maxSuggestedIDV`,
                `${idvData?.insuredDeclaredValue?.maxSuggestedIDV}`,
              );
              setFieldValue(
                `irfPctMin`,
                `${idvData?.insuredDeclaredValue?.irfPctMin}`,
              );
              setFieldValue(
                `idvPctMin`,
                `${idvData?.insuredDeclaredValue?.idvPctMin}`,
              );
              setFieldValue(
                `irfPctMax`,
                `${idvData?.insuredDeclaredValue?.irfPctMax}`,
              );
              setFieldValue(
                `idvPctMax`,
                `${idvData?.insuredDeclaredValue?.idvPctMax}`,
              );
              setIdvValues(idvData);
              setLoadingIDVValues(false);
              return response;
            }
          })
          ?.catch((error) => {
            if (isMounted) {
              setLoadingIDVValues(false);
              setErrorIDVValues(error?.message);
            }
            return error;
          });
      });
    }

    return () => {
      isMounted = false;
    };
  }, [makeCode, varientCode, rtoCode,dateOfReg,
    anyPreviousPolicyforVehicleTaken,
    pastPolicyExpiryDate]);

  if (loadingIDVValues) {
    return (
      <div className="min-h-full">
        <Loading
          textSize={repeat === repeatForMobile ? 'normal' : undefined}
          customMessage={'Fetching insured declared value details'}
        />
      </div>
    );
  }
  if (errorIDVValues) {
    return <Error error={errorIDVValues} />;
  }

  let grid_data = [
   
  //   {
  //     type: 'radiogroup',
  //     label: (
  //       <>
  //         External CNG/LPG Available?<Text severity="error"> *</Text>
  //       </>
  //     ),
  //     colSpan: repeat,
  //     name: 'isCngLpgAvailable',
  //     disabledGlobal:
  //       values?.quotationNo !== '',
    
  //     data: [
  //       {
  //         label: 'Yes',
  //         value: 'Yes',
  //       },
  //       {
  //         label: 'No',
  //         value: 'No',
  //       },
  //     ],
  //   },
  //  //(values?.isCngLpgAvailable === 'Yes')?
  //  (true) ?
  //   {
  //     type: 'text', 
  //     size:'medium',
  //     label: (
  //       <>
  //         CNG/ LPG KIT Sum Insured<Text severity="error"> *</Text>
  //       </>
  //     ),
  //     colSpan: repeat,
  //     name: 'cngLpgSumInsured',

  //   }
  //    : null,
    {
      type: 'render',
      name: 'suggestedIDV',
      component: () => (
        <div className="flex flex-col mt-3">
          <Text type="label">Suggested Chasis IDV</Text>
          <span>
            {makeCode && varientCode && rtoCode ? (
              CurrencyFormater(
                parseFloat(
                  idvValues?.insuredDeclaredValue?.suggestedIDV ||
                    values?.suggestedIDV,
                ),
                true,
                false,
                branding,
                false
              )
            ) : (
              <Text className="text-neutral-dark">Not Captured</Text>
            )}
          </span>
          <span>
            <Text severity="error" type="label">
              {errorIDVValues}
            </Text>
          </span>
        </div>
      ),
    },
    {
      type: 'render',
      component: () => (
        <div className="flex flex-col space-y-2">
          <div>
            <QuantaInput
              type={'number'}
              size={'large'}
              iconPre={
                <Text
                  severity={
                    !makeCode ||
                    !varientCode ||
                    !rtoCode ||
                    (values?.quotationNo !== '' && !modify )
                      ? 'neutral'
                      : 'info'
                  }
                >
                  {branding.currency}
                </Text>
              }
              label={
                <>
                  Changed Chasis IDV<Text severity="error"> *</Text>
                </>
              }
              name={'changedIDV'}
              className={`${
                !makeCode ||
                !varientCode ||
                !rtoCode ||
                !(values?.quotationNo !== '' && !modify )
                  ? 'border-neutral-dark'
                  : ''
              }`}
              disabled={
                !makeCode ||
                !varientCode ||
                !rtoCode ||
                (values?.quotationNo !== '' && !modify )
              }
              noerror={
                values?.changedIDV !== '' &&
                values?.maxSuggestedIDV !== '' &&
                values?.minSuggestedIDV !== ''
                  ? parseFloat(values?.changedIDV) >=
                      parseFloat(values?.minSuggestedIDV) &&
                    parseFloat(values?.changedIDV) <=
                      parseFloat(values?.maxSuggestedIDV)
                  : false
              }
              enableSlider={
                !makeCode || !varientCode || !rtoCode ? false : true
              }
              sliderMin={
                idvValues?.insuredDeclaredValue?.minSuggestedIDV !==
                  undefined &&
                idvValues?.insuredDeclaredValue?.minSuggestedIDV !==
                  null
                  ? parseFloat(
                      idvValues?.insuredDeclaredValue
                        ?.minSuggestedIDV,
                    )
                  : 0
              }
              sliderMax={
                idvValues?.insuredDeclaredValue?.maxSuggestedIDV !==
                  undefined &&
                idvValues?.insuredDeclaredValue?.maxSuggestedIDV !==
                  null
                  ? parseFloat(
                      idvValues?.insuredDeclaredValue
                        ?.maxSuggestedIDV,
                    )
                  : 0
              }
              sliderStep={1}
              value={
                values?.changedIDV!=0
                  ? Math.round(parseFloat(values?.changedIDV))
                  : Math.round(parseFloat(values?.suggestedIDV))
              }
              initialValue={
                values?.suggestedIDV
                  ? Math.round(parseFloat(values?.suggestedIDV))
                  : null
              }
            />
          </div>
          {idvValues?.insuredDeclaredValue?.idvPctMax &&
            idvValues?.insuredDeclaredValue?.idvPctMin &&
            !(values?.quotationNo && !modify ) && ( //check
              <Text
                severity={'info'}
                type={'normal'}
                className={'flex space-x-1 break-words'}
              >
                <span>
                  <FontAwesomeIcon icon={faInfoCircle} />
                </span>
                <span>
                  You can choose maximum{' '}
                  {idvValues?.insuredDeclaredValue?.idvPctMax}% and
                  minimum {idvValues?.insuredDeclaredValue?.idvPctMin}
                  % deviation from the suggested IDV
                </span>
              </Text>
            )}
        </div>
      ),
    },
    // {
    //   type: 'render',
    //   component: () => (
    //     <div className="flex flex-col space-y-2">
    //       <div>
    //         <QuantaInput
    //           type={'number'}
    //           size={'large'}
    //           label={
    //             <>
    //               Adjustment - IRF <Text severity="error">*</Text>
    //             </>
    //           }
    //           name={'adjustmentIRF'}
    //           className={`${
    //             !makeCode ||
    //             !varientCode ||
    //             !rtoCode ||
    //             values?.quotationNo !== ''
    //               ? 'border-neutral-dark'
    //               : ''
    //           }`}
    //           iconPre={
    //             <Text
    //               severity={
    //                 !makeCode ||
    //                 !varientCode ||
    //                 !rtoCode ||
    //                 values?.quotationNo !== ''
    //                   ? 'neutral'
    //                   : 'info'
    //               }
    //             >
    //               {`%`}
    //             </Text>
    //           }
    //           disabled={
    //             !(
    //               makeCode &&
    //               varientCode &&
    //               rtoCode &&
    //               values?.quotationNo === ''
    //             )
    //           }
    //           noerror={
    //             values?.adjustmentIRF !== '' &&
    //             parseFloat(values?.adjustmentIRF) >=
    //               -parseFloat(values?.irfPctMin) &&
    //             parseFloat(values?.adjustmentIRF) <=
    //               parseFloat(values?.irfPctMax)
    //           }
    //           enableSlider={
    //             makeCode && varientCode && rtoCode ? true : false
    //           }
    //           sliderMin={
    //             -parseFloat(
    //               idvValues?.insuredDeclaredValue?.irfPctMin,
    //             )
    //           }
    //           sliderMax={parseFloat(
    //             idvValues?.insuredDeclaredValue?.irfPctMax,
    //           )}
    //           sliderStep={1}
    //           value={
    //             values?.adjustmentIRF
    //               ? parseFloat(values?.adjustmentIRF)
    //               : ''
    //           }
    //           initialValue={
    //             idvValues?.insuredDeclaredValue?.irfPctMin &&
    //             idvValues?.insuredDeclaredValue?.irfPctMax
    //               ? 0
    //               : 0
    //           }
    //         />
    //       </div>
    //       {idvValues?.insuredDeclaredValue?.irfPctMax &&
    //         idvValues?.insuredDeclaredValue?.irfPctMin &&
    //         !values?.quotationNo && (
    //           <Text
    //             severity={'info'}
    //             type={'normal'}
    //             className={'flex space-x-1 break-words'}
    //           >
    //             <span>
    //               <FontAwesomeIcon icon={faInfoCircle} />
    //             </span>
    //             <span>
    //               You can choose up to maximum{' '}
    //               {idvValues?.insuredDeclaredValue?.irfPctMax}% and
    //               minimum -
    //               {idvValues?.insuredDeclaredValue?.irfPctMin}%
    //             </span>
    //           </Text>
    //         )}
    //     </div>
    //   ),
    // },
    {
      type: 'text',
      label: (
        <>Body IDV<Text severity="error"></Text>
        </>
      ),
      name: `bodyIDV`,
      // disabled:true,
       disabled: (values?.quotationNo !== '' && !modify ),
      className: `${(values?.quotationNo !== '' && !modify ) ? 'border-neutral-dark' : ''
        }`,
      iconPre: (
        <Text
          severity={
            (values?.quotationNo !== '' && !modify ) ? 'neutral-darker' : 'info'
          }
        >
         {branding.currency}
        </Text>
      ),
  },
  {
    type: 'render',
    name: 'totalIDV',
    component: () => (
      <div className="flex flex-col mt-3">
        <Text type="label">Total IDV</Text>
        <span>
          {makeCode && varientCode && rtoCode ? (
            CurrencyFormater(
                result
                ?result
                :values?.changedIDV,
              true,
              false,
              branding,
              false
            )
          ) : (
            <Text className="text-neutral-dark">Not Captured</Text>
          )}
        </span>
        <span>
          <Text severity="error" type="label">
            {errorIDVValues}
          </Text>
        </span>
      </div>
    ),
  },
  ];

  return (
     <InputGrid
      data={grid_data}
      repeat={repeat}
      titleType="title"
      titleSeverity="info"
      size="large"
      gapX={10}
    />
   
  );
}
